import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { SsnAutocompleteComponent } from './ssn-autocomplete.component';

@NgModule({
  declarations: [SsnAutocompleteComponent],
  imports: [CommonModule, MatAutocompleteModule, FormsModule, NgxMaskDirective, NgxMaskPipe, ReactiveFormsModule],
  providers: [provideNgxMask()],
  exports: [SsnAutocompleteComponent],
})
export class SsnAutocompleteModule {}
